export default __webpack_public_path__ + "assets/saotomeandprincipe-flag.png";